<template>
  <v-container fluid grid-list-md>
    <v-layout justify-space-between row wrap>
      <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
        <v-list three-line light class="py-0 elevation-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
   
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <v-subheader>Custos Indiretos e Lucro</v-subheader> 
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Custos Indiretos / Despesas Administrativas (em %)" 
          v-bind="currency_config"
          v-model="moduleSix.administrativeCosts"
          :hint="administrativeCostsValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm6>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Lucro (em %)" 
          v-bind="currency_config"
          v-model="moduleSix.lucre"
          :hint="lucreValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
    </v-layout>
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <v-subheader>Tributação pelo {{taxationType}} (*valores de acordo com o cadastro da empresa)</v-subheader> 
      </v-flex>
      <v-flex xs12 v-if="taxationType.toUpperCase() == 'SIMPLES NACIONAL'">
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Taxação Única (em %)" 
          v-bind="currency_config"
          v-model="budget.company.taxation.uniqueTaxation"
          :hint="uniqueTaxationValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 v-else-if="taxationType.toUpperCase() != ''">
        <v-layout row wrap>
          <v-flex xs12 sm8>
            <h4>Tributos Federais</h4>
            <v-layout row wrap>
              <v-flex xs6>
                <v-currency-field 
                  box :readonly="budgetFinalized"
                  label="PIS (em %)" 
                  v-bind="currency_config"
                  v-model="budget.company.taxation.pis"
                  :hint="pisValue | currency" 
                  persistent-hint
                >
                
                </v-currency-field>
              </v-flex>
              <v-flex xs6>
                <v-currency-field 
                  box :readonly="budgetFinalized"
                  label="COFINS (em %)" 
                  v-bind="currency_config"
                  v-model="budget.company.taxation.cofins"
                  :hint="cofinsValue | currency" 
                  persistent-hint
                >
                </v-currency-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm4>
            <h4>Tributos Municipais</h4>
            <v-layout row wrap>
              <v-flex xs16>
                <v-currency-field 
                  box :readonly="budgetFinalized"
                  label="ISS (em %)" 
                  v-bind="currency_config"
                  v-model="budget.company.taxation.iss"
                  :hint="issValue | currency" 
                  persistent-hint
                >
                </v-currency-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!--<v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <v-subheader>Outros Tributos</v-subheader>
        <v-btn color="primary" title="Adicionar benefício" @click.native.stop.prevent="addOtherTaxation();">
        Adicionar
        <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-layout xs12 v-for="(other, i) in moduleSix.others" :key="i" row wrap>
          <v-flex xs11>
            <v-layout row wrap>
              <v-flex xs7>
                <v-text-field label="Descrição" v-model="other.description" box></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-currency-field 
                  box
                  label="Porcentagem (%)" 
                  v-bind="currency_config"
                  v-model="other.value"
                  persistent-hint
                  :hint="calculateOtherValue(other) | currency">

                </v-currency-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1>
            <v-layout justify-center align-center fill-height>
              <v-icon color="red" class="font-weight-black" title="Remover Taxação" @click.stop.prevent="removeTaxation(other);">delete_forever</v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>-->
    <v-layout row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
      </v-flex>
      <v-flex xs12 class="pt-0">
        <v-textarea v-model="moduleSix.notes" label="Notas" rows="5" box :readonly="budgetFinalized"></v-textarea>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import SheetDefaultData from '../../data/sheet/SheetDefaultData'
  import {mapState} from "vuex";
  import Currency from '../../utils/Currency';
import ModuleSixService from '../../service/ModuleSixService';

  export default {
    name: "TabModule6",

    data() {
      return {
        currency_config: Currency.percent,
      };
    },
    methods: {
      addOtherTaxation(){
        this.moduleSix.others.push({
          description: "",
          value: 0
        });
      },
      calculateOtherValue(other){
        if(!this.taxation)
          return 0
        return (this.basisOfCalculationForTaxation / (100 - this.aliquot)) * other.value
      },
      removeTaxation(other) {
        this.moduleSix.others.splice(this.moduleSix.others.indexOf(other), 1);
      },
      async setSheetModuleSix() {
        let sheet = this.analyticalWorksheet
          if(sheet.moduleSix != this.moduleSix){
            sheet.moduleSix = Object.assign({}, this.moduleSix)
            await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
          }
      }, // setSheetModuleSix()
    },

    computed: {
      administrativeCostsValue() {
        return ModuleSixService.getAdministrativeCosts(this.subTotalValue, this.moduleSix.administrativeCosts)
      },
      aliquot() {
        return ModuleSixService.getAliquot(this.taxation, this.taxationType)        
      },
      amountOfModuleSix(){
        let amount = ModuleSixService.getAmountOfModuleSix(this.budget, this.moduleSix, this.subTotalValue)
        this.$store.commit("SET_AMOUNT_OF_MODULE_SIX", amount);
        return amount
      },
      basisOfCalculationForLucre (){
        return ModuleSixService.getBasisOfCalculationForLucre(this.subTotalValue, this.administrativeCostsValue)
      },
      basisOfCalculationForTaxation(){
        return ModuleSixService.getBasisOfCalculationForTaxation(this.subTotalValue, this.administrativeCostsValue, this.lucreValue)
      },
      cofinsValue() {
         return ModuleSixService.getCofins(this.taxation, this.basisOfCalculationForTaxation, this.aliquot)
      },
      informations(){
        return  [
          {
            class: "xs12 sm6 md3",
            title: "Base de Cálculo dos Custos Indiretos",
            subtitle: "Sub-Total (Soma dos Módulos 1, 2, 3, 4 e 5)",
            value: this.subTotalValue
          },
          {
            class: "xs12 sm6 md3",
            title: "Base de Cálculo do Lucro",
            subtitle: "Sub-Total + Custos Indiretos",
            value: this.basisOfCalculationForLucre
          },
          {
            class: "xs12 sm6 md3",
            title: "Base de Cálculo da Tributação",
            subtitle: "Sub-Total + Custos Indiretos + Lucro",
            value: this.basisOfCalculationForTaxation
          },
          {
            class: "xs12 sm6 md3",
            title: "Base de Cálculo da Tributação",
            subtitle: this.taxationType.toUpperCase() != 'SIMPLES NACIONAL' ? `Alíquota: ${this.aliquot}%` : "",
            value: this.amountOfModuleSix
          },
        ]
      },
      issValue() {
        return ModuleSixService.getIss(this.taxation, this.basisOfCalculationForTaxation, this.aliquot)
      },
      lucreValue() {
        return ModuleSixService.getLucre(this.moduleSix.lucre, this.basisOfCalculationForLucre)
      },
      moduleSix(){
        if(this.analyticalWorksheet.moduleSix)
          return this.analyticalWorksheet.moduleSix
        
        return SheetDefaultData.getModuleFive()
      },
      othersValue(){
        return ModuleSixService.getOthers(this.moduleSix.others, this.aliquot, this.basisOfCalculationForTaxation)
      },
      pisValue() {
        return ModuleSixService.getPis(this.taxation, this.basisOfCalculationForTaxation, this.aliquot)
      },
      subTotalValue() {
        return  this.amountOfModuleOne   +
                this.amountOfModuleTwo   +
                this.amountOfModuleThree +
                this.amountOfModuleFour  +
                this.amountOfModuleFive
      },
      taxation(){
        return ModuleSixService.getTaxation(this.budget)
      },
      taxationType(){
        return ModuleSixService.getTaxationType(this.taxation)
      },
      uniqueTaxationValue(){
        return ModuleSixService.getUniqueTaxation(this.taxation, this.basisOfCalculationForTaxation)
      },
      ...mapState({amountOfModuleOne  : state => state.budget.amountOfModuleOne}),
      ...mapState({amountOfModuleTwo  : state => state.budget.amountOfModuleTwo}),
      ...mapState({amountOfModuleThree: state => state.budget.amountOfModuleThree}),
      ...mapState({amountOfModuleFour : state => state.budget.amountOfModuleFour}),
      ...mapState({amountOfModuleFive : state => state.budget.amountOfModuleFive}),
      ...mapState({analyticalWorksheet: state => state.budget.analyticalWorksheet}),
      ...mapState({budget             : state => state.budget.budget}),      
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized})
    },
    watch: {
      moduleSix: {
        handler: function(newValue, oldValue) {
          this.setSheetModuleSix()
        },
        deep: true
      }
    }
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/TabModule6.vue